import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {TreeItemNode} from '../model/tree/tree-item-node.model';
import {TreeItemFlatNode} from '../model/tree/tree-item-flat-node.model';

@Injectable({
    providedIn: 'root'
})
export class TreeDataService {

    // place
    private readonly dataAllPlace = new BehaviorSubject(new Array<TreeItemNode>());
    public allPlacesMessager = this.dataAllPlace.asObservable();

    private readonly dataAllExcludePlace = new BehaviorSubject(new Array<TreeItemNode>());
    public allExcludePlacesMessager = this.dataAllExcludePlace.asObservable();

    private readonly dataChoixPlaceInscription = new BehaviorSubject(new Array<TreeItemFlatNode>());
    public choixPlacesInscriptionMessager = this.dataChoixPlaceInscription.asObservable();

    /** Autre enfant **/
    private readonly dataAllExcludePlaceOther = new BehaviorSubject(new Array<TreeItemNode>());
    public allExcludePlacesOtherMessager = this.dataAllExcludePlaceOther.asObservable();

    private readonly dataChoixPlaceOtherInscription = new BehaviorSubject(new Array<TreeItemFlatNode>());
    public choixPlacesOtherInscriptionMessager = this.dataChoixPlaceOtherInscription.asObservable();


    // place
    changeAllPlace(placeList: TreeItemNode[]) {
        this.dataAllPlace.next(placeList);
    }

    changeChoixPlaceInscription(placeList: TreeItemFlatNode[]) {
        this.dataChoixPlaceInscription.next(placeList);
    }

    changeChoixPlaceOtherInscription(placeList: TreeItemFlatNode[]) {
        this.dataChoixPlaceOtherInscription.next(placeList);
    }

    addExcludePlace(place: TreeItemNode) {
        const currentList = this.dataAllExcludePlace.getValue();
        currentList.push(place);
        this.dataAllExcludePlace.next(currentList);
    }

    removeExcludePlace(placeId: number) {
        const currentList = this.dataAllExcludePlace.getValue();
        const search = currentList.find(item => item.id === placeId);
        const index = currentList.indexOf(search);
        currentList.splice(index, 1);

        this.dataAllExcludePlace.next(currentList);
    }

    resetAllExcludePlace() {
        this.dataAllExcludePlace.next([]);
    }

    reset() {
        this.resetAllExcludePlace();
        this.changeAllPlace([]);
        this.changeChoixPlaceInscription([]);
        this.changeChoixPlaceOtherInscription([]);
    }

}
